import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=382cea98&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/pc/footer.scss?vue&type=style&index=0&id=382cea98&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382cea98",
  null
  
)

export default component.exports